<template>
  <card v-loading="loading">
    <div slot="header" class='card-title'>
      <h4>{{ $t('Statistics') }}</h4>
      <p class="period">{{$t('For the last month')}}</p>
    </div>
    <div class="empty" v-if="data.length === 0">
      {{ $t('No operations') }}
    </div>
    <div v-else>
      <ul v-for="(events, key) in groupedData" :key="key">
        <li>
          <div class="day">{{ eventDate(key) }}</div>
          <ul>
            <li v-for="(event, index) in events" :key="index" class="event">
              <div class="event-info">
                <div class="event-type description">
                    {{ $t(event.type.charAt(0).toUpperCase() + event.type.slice(1)) }}
                </div>
                <div class="event-description">
                  {{ event.description }}
                </div>
              </div>
              <div :class="eventClass(event.type)">
                {{ formatPrice(event.amount) + ' ' + event.currency}}
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </card>
</template>

<script>
import { Table, TableColumn, Radio, RadioGroup, RadioButton } from 'element-ui'
import number from '../mixins/number'
import { parseISO, format, isToday, isYesterday, differenceInWeeks } from 'date-fns'
import { ru, az } from 'date-fns/locale'
import { groupBy } from 'lodash'

export default {
  name: 'Statistics',
  mixins: [number],
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-radio-group': RadioGroup,
    'el-radio': Radio,
    'el-radio-button': RadioButton
  },
  props: {
    data: {
      required: true
    },
    loading: {
      type: Boolean
    },
    agrmid: {
      type: Number
    }
  },
  computed: {
    groupedData () {
      return groupBy(this.data, 'date')
    }
  },
  methods: {
    eventDate(date) {
      const parsedDate = parseISO(date)
      if (isToday(parsedDate)) {
        return this.$t('Today')
      }
      if (isYesterday(parsedDate)) {
        return this.$t('Yesterday')
      }
      const dateFormat = differenceInWeeks(new Date(), parsedDate) > 1 ? 'd MMMM' : 'd MMMM, EEEE'
      const locale = this.$i18n.locale === 'az' ? az : ru
      return format(parsedDate, dateFormat, { locale: locale })
      // return this.$d(parsedDate, differenceInWeeks(new Date(), parsedDate) > 1 ? 'shortDay' : 'shortDayWithWeekday')
    },
    eventClass(type = 'writeoff') {
      if (type === 'payment') {
        return 'event-amount event-amount--payment'
      } else {
        return 'event-amount'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  margin: 0;
}
.card-header {
  padding-left: 0;
  padding-right: 0;
}
.period {
  margin-bottom: 0;
  color: #9A9A9A;
  line-height: 1;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.day {
  margin-left: -15px;
  margin-right: -15px;
  padding: 10px 15px;
  background-color: #f5f7fa;
  color: #9A9A9A;
}
.event {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 20px 0;
  &:not(:last-child) {
    border-bottom: 1px solid #E3E3E3;

  }
}
.event-logo {
  flex-grow: 0;
  margin-right: 30px;
}
.event-info {
  flex: 1;
}
.event-description {
  font-size: 16px;
}
.event-amount {
  font-size: 20px;
  font-weight: 200;
}
.event-amount--payment {
  color: #18ce0f
}
.event-type {
  line-height: 1
}
.empty {
  text-align: center;
  color: #909399
}
</style>
